import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

interface Contact {
  name: string;
  email?: string;
  phone?: string;
}

interface Bid {
  id: string;
  broker: Contact;
  client: Contact;
}

interface BidDetailsProps {
  bids: Bid[];
}

const BidDetails: React.FC<BidDetailsProps> = ({ bids }) => {
  return (
    <div className="p-2 mx-auto">
      {/* Page Header */}
      <Typography variant="h5" className="mb-6 font-bold text-gray-800">
        Bid Details
      </Typography>

      {/* Full Deal Info Button */}
      <Button
        variant="contained"
        color="primary"
        sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
        fullWidth
      >
        Full Deal Info
      </Button>

      <div className="mt-6 space-y-6">
        {bids.map((bid) => (
          <Card key={bid.id} className="rounded-2xl shadow-md">
            <CardContent>
              {/* Broker Contact */}
              <Typography
                variant="h6"
                className="font-semibold text-gray-700 mb-3"
              >
                Broker Contact
              </Typography>
              <div className="flex items-center gap-3 mb-2">
                <EmailIcon color="action" />
                <Typography className="text-gray-800">
                  {bid.broker.email || "N/A"}
                </Typography>
              </div>
              <div className="flex items-center gap-3 mb-4">
                <PhoneIcon color="action" />
                <Typography className="text-gray-800">
                  {bid.broker.phone || "N/A"}
                </Typography>
              </div>

              {/* Divider */}
              <hr className="border-gray-200 my-3" />

              {/* Client Contact */}
              <Typography
                variant="h6"
                className="font-semibold text-gray-700 mb-3"
              >
                Client Contact
              </Typography>
              <Typography className="text-gray-800">
                {`${(bid.client as any).firstName || ''} ${(bid.client as any).middleName || ''} ${(bid.client as any).lastName || ''}`.trim()}
              </Typography>
              {bid.client.phone && (
                <div className="flex items-center gap-3 mt-2">
                  <PhoneIcon color="action" />
                  <Typography className="text-gray-800">
                    {bid.client.phone}
                  </Typography>
                </div>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

// Example usage with dummy data
export default function BidDetailsPage() {
  const bids: Bid[] = [
    {
      id: "1",
      broker: {
        name: "test Broker",
        email: "test.broker@email.com",
        phone: "+1-555-123-4567",
      },
      client: {
        name: "test Client",
        phone: "+1-555-987-6543",
      },
    },
    {
      id: "2",
      broker: {
        name: "test2 Broker",
        email: "test2.broker@email.com",
        phone: "+1-555-111-2222",
      },
      client: {
        name: "Bob Client",
        phone: "+1-555-333-4444",
      },
    },
  ];

  return <BidDetails bids={bids} />;
}
